import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CurveService } from 'src/app/shared/curve-service/curve.service';
import { ExpertService } from 'src/app/shared/techExpert/expert.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { environment } from 'src/environments/environment';
import { TicketService } from 'src/app/shared/customer/ticket/ticket.service';

@Component({
    selector: 'app-get-assigned-tickets',
    templateUrl: './get-assigned-tickets.component.html',
    styleUrls: ['./get-assigned-tickets.component.css'],
    standalone: false
})
export class GetAssignedTicketsComponent implements OnInit {
  alltickets
  allpending: []
  allresolved: []
  tickets
  pending
  resolved
  startDate
  endDate
  role
  attachments
  serverErrorMessages: string
  showTickets :Boolean [] = [];
  graphDetails;
  environment
  closeResult
  ticketID
  messages: any[] = [];
  expertMessage : string;
  filterForm = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
  })
  ticketReplyForm = new FormGroup({
    message: new FormControl('', [Validators.required])
  })
  disableButton = true;
  checkButton = false;
  position = 'above';
  file: File;
  imageUrl: string | ArrayBuffer = "";
  fileName: string = "No file selected";
  constructor(private loginService: LoginService,private ticketService: TicketService, private expertService: ExpertService, private router : Router, private modalService: NgbModal, private datePipe: DatePipe, private curveService: CurveService) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllTickets();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllTickets(){
    this.expertService.getAllTickets().subscribe(
      res => {
        this.alltickets = res['tickets'];
        this.allpending = res['pending'];
        this.allresolved = res['resolved'];
        this.pending=this.allpending;
        this.resolved=this.allresolved;
        this.tickets=this.alltickets;
        console.log(this.tickets)
        // this.tickets.forEach(a => { this.showTickets.push(false) })
       //console.log('Got tickets', res, this.alltickets);
      },
      err => {
       //console.log('Error getting tickets', err)
      }
    )
  }

  repltToTicket(ticket){
    this.expertService.changeTicket(ticket);
   // this.router.navigateByUrl('/reply-to-ticket');
  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }



  transformDate(date){
    return this.datePipe.transform(date, 'yyyy-MM-dd')
  }

  sendCurveDataToAnalyser(id, heatNumber){
    this.curveService.getCurveDataById({curveId: id}).subscribe(res=>{
      ////console.log('got curve details', res);
      this.graphDetails = res['curveData'];
     //console.log(this.graphDetails)
      // this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives})
      this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:this.graphDetails.paid, curveID:id, heatNumber:"sample_heat_number"})
      this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:this.graphDetails.paid, curveID:id, heatNumber:heatNumber, heatId: this.graphDetails.heatId})
    // Heat id DISPLAYING   Changing date 13-04-2024  -- by Rajadurai
      this.router.navigateByUrl('analyze-curve');
    },
    err => {
     //console.log('got error', err)
    })
   //console.log('send data to analyzer')
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  openChat(content, messages, ticketID) {
    ////console.log(content, typeof(content))
    this.messages = messages;
    this.ticketID = ticketID;
   //console.log(messages)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {

      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  replyToTicket(){
   console.log(this.ticketReplyForm.value.message, this.ticketID);

    this.expertService.replyToTicket({ expertMessage: this.ticketReplyForm.value.message, ticketID: this.ticketID,role : "TECHEXPERT" }
    ,this.file).subscribe(
      res => {
       //alert('Your Reply was successfully Taken, Thank you for your service. You can close the chat window now.');
        alert(res['message']);

        // this.router.navigateByUrl('get-assigned-tickets');
       //  this.router.navigateByUrl('/', {skipLocationChange: true})
      //   .then(() => this.router.navigate(['/get-assigned-tickets']));

      },
      err => {
       //console.log('Reply Error from server');
      alert(err)
      }
    )
  }


  openAllAttachments(content,ticket_id)
  {
    this.environment = environment;
    this.expertService.getAllAttachments({ticketID: ticket_id}).subscribe(
      res => {
        this.attachments = res['attachments'];
       console.log('Got attachments', this.attachments);
      //  this.tickets.reverse();
      //  console.log(this.tickets);
      // console.log("file:",this.attachments[0].file);
        console.log(this.attachments.length)
        this.modalService.open(content, {ariaLabelledBy: 'modal-view-attachment-title'}).result.then((result) => {

          this.closeResult = `Closed with: ${result}`;
         //console.log(this.closeResult)
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

        });
      },
      err => {
       console.log('Error getting attachments', err)
        this.serverErrorMessages = err.error.message;
      }
    )
  }

  filter(){
    //Handle edge cases
    this.startDate=this.transformDate(this.filterForm.get('startDate').value)
    this.endDate=this.transformDate(this.filterForm.get('endDate').value)
    this.tickets = []
    this.pending = []
    this.resolved =[]
    for (var x of this.alltickets) {
      var d = this.transformDate(x.createdAt)
      if (d>=this.startDate && d<=this.endDate) {
        this.tickets.push(x);
        if (x.isOpen) this.pending.push(x);
        else this.resolved.push(x);
      }
    }
  }

  reset(){
    this.tickets = this.alltickets
    this.pending = this.allpending
    this.resolved = this.allresolved
    this.filterForm.reset();
  }

  checkIfEmail($event){
    // if(this.ticketReplyForm.get('message').value == ''){
    //   this.disableButton = true
    // }
    // console.log('message is :', this.ticketReplyForm.get('message').value)
    const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const phoneRE = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

    if(this.ticketReplyForm.get('message'))
    {
      this.disableButton = false;
    }
    else{
      this.disableButton = true;
    }

    // this.ticketReplyForm.get('message').value.split(' ').forEach(element => {
    //   // console.log(emailRE.test(element), phoneRE.test(element))
    //   if(emailRE.test(element) || phoneRE.test(element)){
    //     this.checkButton = true;
    //   }else{
    //     this.checkButton = false;
    //   }
    // });
    // console.log(re.test(this.ticketReplyForm.get('message').value))
  }



  openattachment(content) {
    ////console.log(content, typeof(content))

       //console.log(messages)
       if(this.file)
       {
         alert("Attachments already added! To add a new attachment, send the current message and type a new one.")
       }
       else{
        this.modalService.open(content, {ariaLabelledBy: 'modal-attachment-title'}).result.then((result) => {

          this.closeResult = `Closed with: ${result}`;
         //console.log(this.closeResult)
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
         console.log(this.closeResult)
         console.log(this.file)
        });
       }

  }


  onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
        // console.log(this.imageUrl)
      };

    }
  }

}
